import React from 'react';
import styled, { keyframes } from 'styled-components';

const spinAnimation = keyframes`
    0%   { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;

const SpinnerIcon = styled.div`
    width: ${p => p.width}px;
    height: ${p => p.width}px;
    box-sizing: border-box;
    border: solid 2px transparent;
    border-top-color: ${p => p.color};
    border-left-color: ${p => p.color};
    border-radius: 50%;
    animation: ${spinAnimation} 700ms linear infinite;
`;

const Spinner = styled.div`
    display: block;
`;

interface SpinnerProps {
    color?: string;
    width?: number;
    height?: number;
};


const SpinnerComponent = ({ color, width, height }: SpinnerProps) => {
    return (<Spinner><SpinnerIcon width={width ? width : 18} height={height ? height : 18} color={color ? color : '#29d'} /></Spinner>);
};

export default SpinnerComponent;